/**
 * @generated SignedSource<<47b8c3d5364fc0f6d40d53ff57560463>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GoalSortEnum = "CREATION_DATE_ASC" | "CREATION_DATE_DESC" | "HIERARCHY_ASC" | "HIERARCHY_DESC" | "HIERARCHY_LEVEL_ASC" | "HIERARCHY_LEVEL_DESC" | "ID_ASC" | "ID_DESC" | "LATEST_UPDATE_DATE_ASC" | "LATEST_UPDATE_DATE_DESC" | "NAME_ASC" | "NAME_DESC" | "PHASE_ID_ASC" | "PHASE_ID_DESC" | "PROJECT_COUNT_ASC" | "PROJECT_COUNT_DESC" | "SCORE_ASC" | "SCORE_DESC" | "START_DATE_ASC" | "START_DATE_DESC" | "TARGET_DATE_ASC" | "TARGET_DATE_DESC" | "WATCHER_COUNT_ASC" | "WATCHER_COUNT_DESC" | "WATCHING_ASC" | "WATCHING_DESC";
export type GoalsDirectoryEmbedQuery$variables = {
  directoryViewUuid?: string | null;
  isOkrHubView: boolean;
  q?: string | null;
  sort?: ReadonlyArray<GoalSortEnum | null> | null;
  workspaceUuid: string;
};
export type GoalsDirectoryEmbedQuery$data = {
  readonly expandableGoalsList?: {
    readonly " $fragmentSpreads": FragmentRefs<"ExpandableGoalsList">;
  } | null;
  readonly okrHub?: {
    readonly " $fragmentSpreads": FragmentRefs<"OkrHubDirectoryView">;
  } | null;
};
export type GoalsDirectoryEmbedQuery = {
  response: GoalsDirectoryEmbedQuery$data;
  variables: GoalsDirectoryEmbedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "directoryViewUuid"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isOkrHubView"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "q"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sort"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceUuid"
},
v5 = {
  "kind": "Variable",
  "name": "directoryViewUuid",
  "variableName": "directoryViewUuid"
},
v6 = {
  "kind": "Variable",
  "name": "q",
  "variableName": "q"
},
v7 = {
  "kind": "Variable",
  "name": "workspaceUuid",
  "variableName": "workspaceUuid"
},
v8 = {
  "kind": "Variable",
  "name": "sorts",
  "variableName": "sort"
},
v9 = [
  (v5/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 40
  },
  (v6/*: any*/),
  (v8/*: any*/),
  (v7/*: any*/)
],
v10 = {
  "kind": "ScalarField",
  "name": "id"
},
v11 = {
  "kind": "ScalarField",
  "name": "key"
},
v12 = {
  "kind": "ScalarField",
  "name": "name"
},
v13 = {
  "args": [
    {
      "kind": "Literal",
      "name": "includeScore",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "label",
  "storageKey": "label(includeScore:false)"
},
v14 = [
  {
    "kind": "ScalarField",
    "name": "messageId"
  }
],
v15 = {
  "concreteType": "LocalizationField",
  "kind": "LinkedField",
  "name": "localizedLabel",
  "plural": false,
  "selections": (v14/*: any*/)
},
v16 = {
  "kind": "ScalarField",
  "name": "score"
},
v17 = {
  "kind": "ScalarField",
  "name": "value"
},
v18 = [
  {
    "kind": "Literal",
    "name": "longFormat",
    "value": true
  }
],
v19 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v20 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v21 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v22 = [
  (v5/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  (v6/*: any*/),
  (v8/*: any*/),
  (v7/*: any*/)
],
v23 = {
  "kind": "ScalarField",
  "name": "count"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GoalsDirectoryEmbedQuery",
    "selections": [
      {
        "condition": "isOkrHubView",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": [
                    (v5/*: any*/),
                    (v6/*: any*/),
                    {
                      "kind": "Variable",
                      "name": "sort",
                      "variableName": "sort"
                    },
                    (v7/*: any*/)
                  ],
                  "kind": "FragmentSpread",
                  "name": "ExpandableGoalsList"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "expandableGoalsList"
          }
        ]
      },
      {
        "condition": "isOkrHubView",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": [
                    (v5/*: any*/),
                    (v6/*: any*/),
                    (v8/*: any*/),
                    (v7/*: any*/)
                  ],
                  "kind": "FragmentSpread",
                  "name": "OkrHubDirectoryView"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "okrHub"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "GoalsDirectoryEmbedQuery",
    "selections": [
      {
        "condition": "isOkrHubView",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v9/*: any*/),
            "concreteType": "GoalConnection",
            "kind": "LinkedField",
            "name": "goalTqlFullHierarchy",
            "plural": false,
            "selections": [
              {
                "concreteType": "GoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Goal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "uuid"
                      },
                      (v11/*: any*/),
                      {
                        "concreteType": "GoalIcon",
                        "kind": "LinkedField",
                        "name": "icon",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "appearance"
                          }
                        ]
                      },
                      (v12/*: any*/),
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "owner",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "aaid"
                          },
                          {
                            "concreteType": "UserPII",
                            "kind": "LinkedField",
                            "name": "pii",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "picture"
                              },
                              (v12/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "accountStatus"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "accountId"
                              }
                            ]
                          },
                          (v10/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "GoalState",
                        "kind": "LinkedField",
                        "name": "state",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          {
                            "concreteType": "CompletionGoalState",
                            "kind": "LinkedField",
                            "name": "atCompletionState",
                            "plural": false,
                            "selections": [
                              (v13/*: any*/),
                              (v15/*: any*/),
                              (v17/*: any*/),
                              (v16/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "TargetDate",
                        "kind": "LinkedField",
                        "name": "dueDate",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "confidence"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "label"
                          },
                          (v15/*: any*/),
                          {
                            "alias": "tooltip",
                            "args": (v18/*: any*/),
                            "kind": "ScalarField",
                            "name": "label",
                            "storageKey": "label(longFormat:true)"
                          },
                          {
                            "alias": "localizedTooltip",
                            "args": (v18/*: any*/),
                            "concreteType": "LocalizationField",
                            "kind": "LinkedField",
                            "name": "localizedLabel",
                            "plural": false,
                            "selections": (v14/*: any*/),
                            "storageKey": "localizedLabel(longFormat:true)"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "overdue"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasSubgoalMatches"
                      },
                      {
                        "concreteType": "GoalConnection",
                        "kind": "LinkedField",
                        "name": "subGoals",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GoalEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              (v19/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v19/*: any*/)
                    ]
                  },
                  (v20/*: any*/)
                ]
              },
              (v21/*: any*/),
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__id"
                  }
                ]
              }
            ]
          },
          {
            "args": (v9/*: any*/),
            "filters": [
              "q",
              "sorts",
              "directoryViewUuid",
              "workspaceUuid"
            ],
            "handle": "connection",
            "key": "ExpandableGoalsList_goalTqlFullHierarchy",
            "kind": "LinkedHandle",
            "name": "goalTqlFullHierarchy"
          }
        ]
      },
      {
        "condition": "isOkrHubView",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "okrHubGoals",
            "args": (v22/*: any*/),
            "concreteType": "GoalConnection",
            "kind": "LinkedField",
            "name": "goalTqlFullHierarchy",
            "plural": false,
            "selections": [
              (v23/*: any*/),
              {
                "concreteType": "GoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Goal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      {
                        "alias": "successMeasures",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "archived",
                            "value": false
                          },
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 50
                          },
                          {
                            "kind": "Literal",
                            "name": "kind",
                            "value": "SUCCESS_MEASURE"
                          }
                        ],
                        "concreteType": "GoalConnection",
                        "kind": "LinkedField",
                        "name": "subGoals",
                        "plural": false,
                        "selections": [
                          (v23/*: any*/),
                          {
                            "concreteType": "GoalEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "Goal",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v11/*: any*/),
                                  (v12/*: any*/)
                                ]
                              }
                            ]
                          }
                        ],
                        "storageKey": "subGoals(archived:false,first:50,kind:\"SUCCESS_MEASURE\")"
                      },
                      (v19/*: any*/)
                    ]
                  },
                  (v20/*: any*/)
                ]
              },
              (v21/*: any*/)
            ]
          },
          {
            "alias": "okrHubGoals",
            "args": (v22/*: any*/),
            "filters": [
              "q",
              "workspaceUuid",
              "containerId",
              "sorts",
              "directoryViewUuid"
            ],
            "handle": "connection",
            "key": "OkrHubDirectoryView__okrHubGoals",
            "kind": "LinkedHandle",
            "name": "goalTqlFullHierarchy"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "d5445df10a24540184c34bee9f5f931e",
    "id": null,
    "metadata": {},
    "name": "GoalsDirectoryEmbedQuery",
    "operationKind": "query",
    "text": "query GoalsDirectoryEmbedQuery(\n  $q: String\n  $directoryViewUuid: UUID\n  $workspaceUuid: UUID!\n  $sort: [GoalSortEnum]\n  $isOkrHubView: Boolean!\n) {\n  ...ExpandableGoalsList_47e4g9 @skip(if: $isOkrHubView)\n  ...OkrHubDirectoryView_3mxdZK @include(if: $isOkrHubView)\n}\n\nfragment ExpandableGoalsList_47e4g9 on Query {\n  goalTqlFullHierarchy(first: 40, q: $q, sorts: $sort, directoryViewUuid: $directoryViewUuid, workspaceUuid: $workspaceUuid) {\n    edges {\n      node {\n        ...RootGoalEmbedRow\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment GoalEmbedRow on Goal {\n  ...GoalName\n  id\n  owner {\n    ...UserAvatar_1cDMtx\n    id\n  }\n  state {\n    ...GoalState\n  }\n  dueDate {\n    ...TargetDate\n  }\n  hasSubgoalMatches\n  subGoals {\n    edges {\n      __typename\n    }\n  }\n}\n\nfragment GoalName on Goal {\n  uuid\n  id\n  key\n  ...PlatformGoalIcon\n  name\n}\n\nfragment GoalState on GoalState {\n  label(includeScore: false)\n  localizedLabel {\n    messageId\n  }\n  score\n  value\n  atCompletionState {\n    label(includeScore: false)\n    localizedLabel {\n      messageId\n    }\n    value\n    score\n  }\n}\n\nfragment OkrHubDirectoryView_3mxdZK on Query {\n  okrHubGoals: goalTqlFullHierarchy(first: 10, q: $q, workspaceUuid: $workspaceUuid, sorts: $sort, directoryViewUuid: $directoryViewUuid) {\n    count\n    edges {\n      node {\n        id\n        ...OkrHubObjective\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment OkrHubGoalCard on Goal {\n  key\n  name\n}\n\nfragment OkrHubObjective on Goal {\n  ...OkrHubGoalCard\n  successMeasures: subGoals(kind: SUCCESS_MEASURE, archived: false, first: 50) {\n    count\n    edges {\n      node {\n        id\n        ...OkrHubGoalCard\n      }\n    }\n  }\n}\n\nfragment PlatformGoalIcon on Goal {\n  icon {\n    key\n    appearance\n  }\n}\n\nfragment RootGoalEmbedRow on Goal {\n  id\n  ...GoalEmbedRow\n}\n\nfragment TargetDate on TargetDate {\n  confidence\n  label\n  localizedLabel {\n    messageId\n  }\n  tooltip: label(longFormat: true)\n  localizedTooltip: localizedLabel(longFormat: true) {\n    messageId\n  }\n  overdue\n}\n\nfragment UserAvatar_1cDMtx on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n  }\n}\n"
  }
};
})();

(node as any).hash = "dc0d6083942c861d006add7cdb148f15";

export default node;
